module.exports = __webpack_public_path__ + "static/logo-text-1a962056cdfc831132ce43d966245907.svg";